import { UserManager } from '@forge/sso-client';
import { Navigate, useNavigate } from 'react-router-dom';
import { RouteConstants } from '../../constants/constants';
import EmptyDashboard from '../../pages/dashboard/EmptyDashboard'
import { DataStorage } from '../../utils/DataStorage';

import React, { useEffect, useState } from 'react';

export const CallbackRoute = () => {
  const navigate = useNavigate();
  const { user, error } = useAuthCallback();

  useEffect(()=> {
    if(user) {
      if(DataStorage.getDeepLink()) {
        const link = DataStorage.getDeepLink() || RouteConstants.HOME;
        const searchParams = new URL(link).searchParams;
        const pathName = new URL(link).pathname;
        // replace so the one-time-use /callback URL is not kept in browser history
        navigate(`${pathName}?${searchParams}`, { replace: true })
      } else {
        navigate(RouteConstants.HOME, { replace: true })
      }
       
    } else if (error) {
      // stale/already-consumed auth code (e.g. user hit browser Back) - send them to landing page
      navigate(RouteConstants.LANDING_PAGE, { replace: true })
    }
  }, [user, error])
  return <EmptyDashboard/>
};


export const useAuthCallback = () => {
  const [user, setUser] = useState<any>(null);
  const [error, setError] = useState<boolean>(false);
  const userManager = UserManager.getInstance();
  useEffect(() => {
     async function getUser() {
      try {
        const user= await userManager.signinRedirectCallback();
        setUser(user);
      } catch(err) {
        setUser(null);
        setError(true);
      }
     }  
    getUser();
  },[]);
  return { user, error };
  
}
